import React from 'react';
import { ArrowRight, ChevronRight } from 'lucide-react';

// Research-first hero. The healthcare plan is not shipped, so this promises
// nothing: it says what is being studied and asks for the interview.
const openInterview = () => {
  window.dispatchEvent(
    new CustomEvent('sortio-research-open', { detail: { vertical: 'healthcare', source: 'landing_vertical_page' } }),
  );
};

const HealthcareHero = () => {
  return (
    <section className="relative min-h-[80vh] flex items-center text-apple-50 overflow-hidden bg-black pt-[140px] pb-20">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-[10%] left-[15%] w-[35vw] h-[35vw] rounded-full bg-sortio-secondary/20 blur-[120px] animate-float-slow" />
        <div className="absolute bottom-[10%] right-[15%] w-[40vw] h-[40vw] rounded-full bg-sortio-primary/20 blur-[150px] animate-float" />
      </div>

      <div className="container max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20 text-center">
        <div className="inline-flex items-center gap-2 mb-6">
          <div className="flex items-center justify-center px-4 py-1.5 rounded-full bg-sortio-primary/10 border border-sortio-primary/20">
            <span className="text-xs font-medium uppercase tracking-wider text-sortio-primary">Sortio for Healthcare</span>
          </div>
          <div className="flex items-center justify-center px-3 py-1.5 rounded-full bg-amber-400/10 border border-amber-400/30">
            <span className="text-xs font-medium uppercase tracking-wider text-amber-300">In development</span>
          </div>
        </div>

        <h1 className="text-4xl sm:text-5xl md:text-6xl font-medium tracking-tight mb-8 leading-[1.05]">
          We are building Sortio for{' '}
          <span className="apple-gradient-text">healthcare teams</span>, and we are starting with your workflow, not ours.
        </h1>

        <p className="text-lg md:text-xl mb-10 text-apple-200 font-light max-w-2xl mx-auto leading-relaxed">
          Referrals that arrive through a fax portal. Scans that have to reach the right chart. Records
          requests, billing paperwork, prior auths. Before we design the healthcare plan we want to
          understand how that work actually happens, step by step, from the people who do it every day.
          A ten minute research chat is the most useful thing you can give us right now.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            type="button"
            onClick={openInterview}
            className="apple-button text-base px-8 py-4 flex items-center justify-center"
          >
            Take the 10-minute interview <ArrowRight className="ml-2" size={18} />
          </button>
          <a
            href="#notify"
            className="text-apple-50 hover:text-sortio-primary transition-all px-6 py-3 flex items-center justify-center border border-apple-300/30 rounded-full hover:border-sortio-primary"
          >
            Get notified at launch <ChevronRight className="ml-1" size={18} />
          </a>
        </div>
        <p className="mt-6 text-sm text-apple-400">
          Finish the interview and get 50% off your first month of Sortio Pro, today or when the healthcare plan launches.
        </p>
      </div>
    </section>
  );
};

export default HealthcareHero;
